import { render, staticRenderFns } from "./showKnowledge.vue?vue&type=template&id=87dc56ca"
import script from "./showKnowledge.vue?vue&type=script&lang=js"
export * from "./showKnowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports